<template>
    <div class="content-section active" id="dashboard">
        <div class="admin-header">
            <div>
                <h1 class="admin-title">综合管理控制面板</h1>
                <p>校园与音疗产品的整体数据概览</p>
            </div>
            <div class="admin-actions">
                <button class="admin-btn secondary" @click="exportData">
                    <i class="fas fa-file-export"></i> 导出数据
                </button>
                <button class="admin-btn" @click="freshDashData">
                    <i class="fas fa-sync-alt"></i> 刷新数据
                </button>
            </div>
        </div>

        <!-- 统计卡片 -->
        <div class="stats-container">
            <div class="stat-card">
                <div class="stat-header">
                    <div class="stat-title">教育总预约数</div>
                    <div class="stat-icon total">
                        <i class="fas fa-list"></i>
                    </div>
                </div>
                <div class="stat-value">{{ stats.eduTotal }}</div>
            </div>

            <div class="stat-card">
                <div class="stat-header">
                    <div class="stat-title">音疗总预约数</div>
                    <div class="stat-icon sound">
                        <i class="fas fa-headphones"></i>
                    </div>
                </div>
                <div class="stat-value">{{ stats.soundTotal }}</div>
            </div>

            <div class="stat-card">
                <div class="stat-header">
                    <div class="stat-title">教育待处理</div>
                    <div class="stat-icon students">
                        <i class="fas fa-clock"></i>
                    </div>
                </div>
                <div class="stat-value">{{ stats.eduPending }}</div>
            </div>

            <div class="stat-card">
                <div class="stat-header">
                    <div class="stat-title">音疗待处理</div>
                    <div class="stat-icon hotel">
                        <i class="fas fa-clock"></i>
                    </div>
                </div>
                <div class="stat-value">{{ stats.soundPending }}</div>
            </div>
        </div>

        <!-- 新进预约表格 -->
        <div class="data-table-container">
            <div class="admin-header" style="padding: 0; border: none; margin-bottom: 1.5rem;">
                <h1 class="admin-title" style="font-size: 1.5rem;">新进预约信息</h1>
                <div class="filters">
                    <select class="filter-select" v-model="filters.status">
                        <option value="all">所有状态</option>
                        <option value="create">待处理</option>
                        <option value="contacted">已联系</option>
                        <option value="rejected">已拒绝</option>
                    </select>
                    <select class="filter-select" v-model="filters.type">
                        <option value="all">所有类型</option>
                        <option value="teacher">教师</option>
                        <option value="psychologist">心理老师</option>
                        <option value="administrator">学校管理者</option>
                        <option value="parent">家长</option>
                        <option value="other">其他</option>
                    </select>
                    <select class="filter-select" v-model="filters.date">
                        <option value="30">最近30天</option>
                        <option value="7">最近7天</option>
                        <option value="1">今日</option>
                    </select>
                </div>
            </div>

            <table class="data-table">
                <thead>
                    <tr>
                        <th>申请人</th>
                        <th>学校/机构</th>
                        <th>职位</th>
                        <th>联系方式</th>
                        <th>兴趣模块</th>
                        <th>申请时间</th>
                        <th>状态</th>
                        <th>操作</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in filteredAppointments"
                        :key="item.id"
                        :data-id="item.id"
                        :data-type="item.resvType"
                        :data-status="item.state"
                        :data-date="item.date">
                        <td>
                            <div class="user-info">
                                <div class="user-avatar">{{ item.name.charAt(0) }}</div>
                                <div class="user-name">{{ item.name }}</div>
                            </div>
                        </td>
                        <td>{{ item.organization }}</td>
                        <td class="connect-info">{{ item.position }}</td>
                        <td>
                            <div class="connect-info">{{ item.phone }}</div>
                            <div class="connect-info">{{ item.email }}</div>
                        </td>
                        <td>{{getIntestText(item)}}</td>
                        <td class="connect-info">{{ item.submit_time }}</td>
                        <td>
                            <span :class="['status-badge', item.state]">
                                {{ getStatusText(item.state) }}
                            </span>
                        </td>
                        <td>
                            <button class="action-btn view-detail-btn" @click="viewDetail(item)">
                                <i class="fas fa-eye"></i> 查看
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import { jwtDecode } from 'jwt-decode';
    
    import { exportToCSV } from '../../../../csvExport.js';
export default {
    name: 'DashBoard',
    
    created() {
        this.getSummaryInfo();
        this.getLatestReservation();
    },
  data() {
    return {
      stats: {
        eduTotal: 142,
        soundTotal: 89,
        eduPending: 32,
        soundPending: 12
      },
      filters: {
        status: 'all',
        type: 'all',
        date: '30'
      },
      appointments: [
        {
          id: 1,
          name: '张老师-示例',
              organization: '北京市第一中学',
          position: '教师',
          phone: '138****1234',
          email: 'zhang@school.com',
          interest: '教师功能',
          submit_time: '2025-06-18 14:30',
              state: 'contacted',
              resvType: 'edu',
          date: '2025-06-18'
        },
      ]
    }
  },
        computed: {
            filteredAppointments() {
                return this.appointments.filter(item => {
                    const statusMatch = this.filters.status === 'all' || item.state === this.filters.status;
                    const typeMatch = this.filters.type === 'all' || item.resvType === this.filters.type;

                    // Add date filtering logic
                    let dateMatch = true;
                    if (this.filters.date !== '30') { // Only filter if not "30 days" (default)
                        const itemDate = new Date(item.submit_time);
                        const today = new Date();
                        today.setHours(0, 0, 0, 0);

                        if (this.filters.date === '1') { // Today
                            dateMatch = itemDate.toDateString() === today.toDateString();
                        } else if (this.filters.date === '7') { // Last 7 days
                            const sevenDaysAgo = new Date(today);
                            sevenDaysAgo.setDate(today.getDate() - 6); // Include today, so 6 days back
                            dateMatch = itemDate >= sevenDaysAgo && itemDate <= today;
                        }
                    }
                    return statusMatch && typeMatch && dateMatch;
                });
            }
        },
        methods: {
            getIntestText(in_item) {
                const  interest = in_item.interest;

                if (!interest || interest.length == 0) {
                    return "";
                }
                const intestList = interest.split(",");
                const eduInterestMap = {
                    'teacher': '教师功能',
                    'student': '学生功能',
                    'parent': '家长功能',
                    'all': '全部功能'
                };
                const sceneMap = {
                      'company': '企业健康管理',
                      'medical': '医疗辅助',
                      'hotel': '高端酒店服务',
                      'personal': '家庭使用',
                      'other': '其他'
                };
                const translatedList = intestList.map(item => {
                    const trimmedItem = item.trim();
                    if(in_item.resvType == "edu"){
                        return eduInterestMap[trimmedItem] || trimmedItem;    
                    }else{
                        return sceneMap[trimmedItem] || trimmedItem;
                    }
                    
                });
                return translatedList.join("  ") || interest;
            },
            exportData() {
                const headers = [
                    '申请人', '学校/机构', '职位', '联系电话', '电子邮箱',
                    '兴趣模块', '申请时间', '状态'
                ];

                const exportData = this.filteredAppointments.map(item => ({
                    '申请人': item.name || '',
                    '学校/机构': item.organization || '',
                    '职位': item.position || '',
                    '联系电话': item.phone || '',
                    '电子邮箱': item.email || '',
                    '兴趣模块': item.interest || '',
                    '申请时间': item.submit_time || '',
                    '状态': this.getStatusText(item.state) || ''
                }));

                // Export using the utility function
                exportToCSV(headers, exportData, '预约数据');
            },
            async freshDashData() {
                this.$emit('freshShow');
                try {
                    await this.getSummaryInfo();
                    await this.getLatestReservation();
                } finally {
                    this.$emit('freshEnd');
                }
            },
            checkToken() {
                const token = localStorage.getItem('token');
                if (token) {
                    try {
                        const decodedToken = jwtDecode(token);
                        const currentTime = Date.now() / 1000; // 当前时间的秒数
                       
                        if (decodedToken.exp > currentTime) {
                            return true;
                        } else {
                            // Token 已过期，清除本地存储
                            localStorage.removeItem('token');
                            return false;
                        }
                    } catch (error) {
                        console.error('Token 解析失败或用户信息查询失败:', error);
                        localStorage.removeItem('token');
                        return false;
                    }
                    //todo 自动退出
                }
            },
            async getLatestReservation() {
                const isInExpired = await this.$store.dispatch('isInExpired');
                if (!isInExpired) {
                    this.$message({
                        message: "登录已过期，请重新登录",
                        type: "error",
                    });
                    return;
                }
                const token = localStorage.getItem('token');
                try {
                    const payload = {
                        offDay: this.filters.date
                    };
                    const response = await axios.post('/api/reservation/latestDay', payload , {
                        headers: {
                            'Authorization': `Bearer ${token}`
                        }
                    });

                    if (response.status !== 200) {
                        this.$message({
                            message: "网络异常，请稍后尝试",
                            type: "error",
                        });
                        console.error(response.status);
                        return;
                    }
                    if (response.data.code !== "00") {
                        this.$message({
                            message: response.data.message,
                            type: "error",
                        });
                        return;
                    }
                    this.appointments = response.data.info.data;
                    console.log("============latest=====");
                    //console.log(response.data.info.data);
                    console.log(response.data.info.total_records);

                } catch (error) {
                    console.error('summary failed:', error);
                    this.$message({
                        message: "网络异常，请稍后尝试",
                        type: "error",
                    });
                }
            },
            async getSummaryInfo() {
                const isInExpired = await this.$store.dispatch('isInExpired');
                if (!isInExpired) {
                    this.$message({
                        message: "登录已过期，请重新登录",
                        type: "error",
                    });
                    return;
                }
                const token = localStorage.getItem('token');
            try {
                const response = await axios.get('/api/reservation/getSummary',  {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                });

                if (response.status !== 200) {
                    this.$message({
                        message: "网络异常，请稍后尝试",
                        type:"error",
                    });
                    console.error(response.status);
                    return;
                }

                console.log("=================");
                console.log(response.data.data);

                const by_resvType = response.data.data.by_resvType;
                const by_resvType_and_state = response.data.data.by_resvType_and_state;
                let eduPending = 0;
                let soundPending = 0;
                for (var item of by_resvType_and_state) {
                    if (item.state == "create" && item.resvType == "edu") {
                        eduPending = item.count;
                    } else if (item.state == "create" && item.resvType == "sound") {
                        soundPending = item.count;
                    }
                }
                let eduTotal =  by_resvType.edu ? by_resvType.edu:0;
                let soundTotal =  by_resvType.sound ? by_resvType.sound:0;
                this.stats = {
                    eduTotal: eduTotal,
                    soundTotal: soundTotal,
                    eduPending: eduPending,
                    soundPending: soundPending
                };
            } catch (error) {
                console.error('summary failed:', error);
                this.$message({
                    message: "网络异常，请稍后尝试",
                    type: "error",
                });
            }
        },
        //pending    contacted  rejected
        getStatusText(status) {
            const statusMap = {
            'create': '待处理',
            'contacted': '已联系',
            'rejected': '已拒绝',
            };
            return statusMap[status] || status;
        },
        viewDetail(item) {
            // 触发查看详情事件
            this.$emit('view-detail', item);
        }
    }
}
</script>